import internalApi from "../axios/internalApi";
import { message } from "antd";

// Get all FAQs
export const getFaqs = async () => {
  try {
    const response = await internalApi.get({
      server: "api/v1/",
      path: "admin/faq"
    });
    return response;
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Get a single FAQ by ID
export const getFaqById = async (id) => {
  try {
    const response = await internalApi.get({
      server: "api/v1/",
      path: `admin/faq/${id}`
    });
    return response;
  } catch (error) {
    console.error(`Error fetching FAQ with ID ${id}:`, error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Create a new FAQ
export const createFaq = async (faqData) => {
  try {
    const response = await internalApi.post(
      { server: "api/v1/", path: "admin/faq" },
      faqData
    );
    return response;
  } catch (error) {
    console.error("Error creating FAQ:", error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Update an existing FAQ
export const updateFaq = async (id, faqData) => {
  try {
    const response = await internalApi.patch(
      { server: "api/v1/", path: `admin/faq/${id}` },
      faqData
    );
    return response;
  } catch (error) {
    console.error(`Error updating FAQ with ID ${id}:`, error);
    message.error(error?.data?.message);
    throw error;
  }
};

// Delete a FAQ
export const deleteFaq = async (id) => {
  try {
    const response = await internalApi.delete({
      server: "api/v1/",
      path: `admin/faq/${id}`
    });
    return response;
  } catch (error) {
    console.error(`Error deleting FAQ with ID ${id}:`, error);
    message.error(error?.data?.message);
    throw error;
  }
};
